export default function DivisaoSelect({ divisao, value, onChange }) {

    const formatarOpcoes = (divisao) => {
        if (!divisao || typeof divisao !== 'string') return [];

        return divisao.split('||').map((categoria) => ({
            value: categoria,
            label: categoria
        }));
    };

    return (
        <select
            className="form-control"
            value={value}
            onChange={(e) => onChange(e.target.value)}
        >
            <option value="">::Selecione::</option>

            {formatarOpcoes(divisao).map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
}